(function () {
  const nf = new Intl.NumberFormat();

  function calcTotalFromDOM() {
    let total = 0;

    document.querySelectorAll('.entries-cart-line').forEach(line => {
      const qty = Number(line.dataset.qty || 0);
      const price = Number(line.dataset.priceCents || 0);

      const fixed =
        line.dataset.fixed !== '' && !isNaN(line.dataset.fixed)
          ? Number(line.dataset.fixed)
          : null;

      const mult = Number(line.dataset.mult || 40);

      const perUnit =
        fixed !== null
          ? fixed
          : Math.round((price * mult) / 100);

      total += perUnit * qty;
    });

    return total;
  }

  function renderTotal() {
    const wrap = document.querySelector('.entries-cart-estimate');
    if (!wrap) return;

    const total = calcTotalFromDOM();

    const num = wrap.querySelector('.js-cart-entries');

    if (num) {
      num.textContent = nf.format(total);
    }
const dreamBagEntries = document.querySelector('.dreambag-total-entries');

if (dreamBagEntries) {
  dreamBagEntries.textContent = nf.format(total);
}
    queueAttributeUpdate({
      entries_estimate: total
    });
  }

  let timer;

  function queueAttributeUpdate(attrs) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: attrs
        })
      }).catch(() => {});
    }, 300);
  }

  function init() {
    renderTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sleek +code refreshes the cart with this event.
  document.addEventListener('cart:refresh', () => {

    // Wait until the drawer HTML has been replaced.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderTotal();
      });
    });

  });

})();